<template>
  <div class="record-menu-components-df">
    <div class="mian">
      <div class="wrap">
        <ul class="menulist wrapper_menu">
          <li class="menu_item" v-for="(item, idx) in dflotteryTypes" :key="idx" @mouseenter="setIshowIdx(idx)"
            @mouseleave="isShow = null">
            <div class="menu_title"> {{ item.lotteryTypeName }}
              <div class="arrow"></div>
              <ul class="menuItem inner_menu" :class="[
                item.lotteryTypeCode == 'K3' ? 'column-three' : '',
                item.lotteryTypeCode == 'SSC' ? 'column-one' : '',
                item.lotteryTypeCode == 'ZHISHU' ? 'column-one' : '',
                item.lotteryTypeCode == 'DLT' ? 'column-one' : ''
              ]" :style="idx == isShow ? 'display: grid;' : 'display: none;'">
                <li v-for="(item, i) in ltList(item.lotteryTypeCode)" @click="toLottery(item)">{{ item.lotteryName }}
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="record-lottery-component">
          <template>
            <openLottery :list="lotteryLatelyLpVo" :cdn="_cdn + '/'" :lotteryCode="lotteryCode" :page="'lotteryrecord'">
            </openLottery>
          </template>
        </div>
        <div class="record-content">
          <div class="kaijiangjilubox">
            <h3 class="kaijiangjilu">开奖记录</h3>
            <!-- <selectedDate :styleDf="'df'" /> -->
          </div>
        </div>
        <div class="wrapRecord">
          <div class="grid_container">
            <div class="grid_header" :class="lotteryTypeCode == 'PK10' && 'fiveColumn'">
              <div class="grid_column">
                <div class="cell">时间</div>
              </div>
              <div class="grid_column">
                <div class="cell">期号</div>
              </div>
              <div class="grid_column"
                v-if="lotteryTypeCode == 'K3' || lotteryTypeCode == 'SSQ' || lotteryTypeCode == 'DLT'">
                <div class="cell">显示号码</div>
              </div>
              <div class="grid_column" v-else-if="lotteryTypeCode == 'ZHISHU'">
                <div class="cell innerTitle" v-for="(item, i) in zhishuList" :key="i" :class="btnIdx == i && 'clicked'"
                  @click="btnIdx = i">
                  {{ item.name }}
                </div>
              </div>
              <div class="grid_column" v-else>
                <div class="cell innerTitle" v-for="(item, i) in btnList" :key="i" :class="btnIdx == i && 'clicked'"
                  @click="btnIdx = i">
                  {{ item.name }}
                </div>
              </div>
              <div class="grid_column" v-if="lotteryTypeCode == 'K3'">
                <div class="cell">总和</div>
              </div>
              <div class="grid_column"
                v-if="lotteryTypeCode == 'SSC' || lotteryTypeCode == '3D' || lotteryTypeCode == 'PL3' || lotteryTypeCode == '11X5' || lotteryTypeCode == 'SSQ' || lotteryTypeCode == 'DLT' || lotteryTypeCode == 'PCDD'">
                <div class="cell">总和 / 形态</div>
              </div>
              <div class="grid_column" v-if="lotteryTypeCode == 'LHC' || lotteryTypeCode == 'LSC'">
                <div class="cell">总和 / 色波</div>
              </div>
              <div class="grid_column" v-if="lotteryTypeCode == 'PK10'">
                <div class="cell">冠亚和</div>
              </div>
              <div class="grid_column" v-if="lotteryTypeCode == 'PK10'">
                <div class="cell">1-5龙虎</div>
              </div>
              <div class="grid_column" v-if="lotteryTypeCode == 'ZHISHU'">
                <div class="cell">牛熊</div>
              </div>
            </div>
            <div>
              <template>
                <record :ltTypecode="lotteryTypeCode" :lottery="openCurLottery" :f="btnList[btnIdx]['type']" ref="status"></record>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import mix from "~/mixins/home.mixins.vue";
import openLottery from '~/components/openLottery.vue';
import record from "./bet/record";
import selectedDate from "@c/selectedDate";
export default {
  mixins: [mix],
  components: {
    openLottery,
    selectedDate,
    record
  },
  data() {
    return {
      disableMixinMounted: true, //mixins不执行Moutnt
      isShow: null,
      lotteryTypeCode: '',
      lotteryCode: '',
      heavyList: [],
      maxSize: 100,
      btnList: [
        { name: '显示号码', type: 'num' },
        { name: '显示大小', type: 'dx' },
        { name: '显示单双', type: 'ds' }
      ],
      zhishuList: [
        { name: '显示号码', type: 'num' },
        { name: '显示涨跌', type: 'zd' },
        { name: '显示单双', type: 'ds' }
      ],
      btnIdx: 0
    };
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        if (val.name == 'lotteryrecord') {
          if (Object.keys(val.query).length == 0) {
            this.$store.dispatch("lottery/getLotteryLatelyLpVo").then(() => {
              this.defaultlottery();
            })
          } else {
            this.lotteryTypeCode = this.$route.query.lotteryTypeCode
            this.lotteryCode = this.$route.query.lotteryCode
            this.$store.commit("lottery/setlotteryTypeCode", this.lotteryTypeCode);
            this.$store.commit("lottery/setlotteryCode", this.lotteryCode);
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    _cdn() {
      return this.$store.getters['service/cdn']
    },
    // 所有彩票游戏
    hotLotteryList() {
      return this.$store.state.lottery.LotteryLatelyLpVo
    },
    // 获取当前彩种的开奖信息
    openCurLottery() {
      const list = this.$store.state.lottery.LotteryLatelyLpVo || []
      const curInfo = list.find(item => item.lotteryCode == this.lotteryCode)
      return curInfo
    },
    // 大发彩票类型列表
    dflotteryTypes() {
      let list = []
      this.$store.state.lottery.lotteryTypes.forEach((item) => {
        if (item.lotteryTypeName) {
          list.push({
            lotteryTypeName: item.lotteryTypeName,
            lotteryTypeCode: item.lotteryTypeCode
          })
        }
      })
      return list
    },
  },
  mounted() {
    if (Object.keys(this.$route.query).length > 0) {
      this.lotteryTypeCode = this.$route.query.lotteryTypeCode;
      this.lotteryCode = this.$route.query.lotteryCode;
      this.$store.commit("lottery/setlotteryTypeCode", this.lotteryTypeCode);
      this.$store.commit("lottery/setlotteryCode", this.lotteryCode);
      // this.$store.dispatch("lottery/queryHisPeriodsPage"); // 获取开奖历史
      // this.$store.dispatch("lottery/getLotteryLatelyLoop"); // 定时任务
      this.$store.dispatch("lottery/getLotterylist"); // 所有彩种
    }
  },
  beforeDestroy() {
    // this.$store.commit("lottery/setLotteryLatelyLpVo", []);
    this.$store.commit("lottery/clearLotteryLatelyTimer");
    this.$store.commit("lottery/setPage", 1);
  },
  methods: {
    toLottery(item) {
      console.log(this.$refs.status.status);
      if(this.$refs.status.status == false) return
      this.$router.push({
        name: "lotteryrecord",
        query: {
          lotteryTypeCode: item.lotteryTypeCode,
          lotteryCode: item.lotteryCode,
        },
      });
    },
    // 首次进入时默认第一个彩票类型得第一个彩票游戏
    defaultlottery() {
      this.lotteryTypeCode = this.dflotteryTypes[0]['lotteryTypeCode'];
      console.log(this.hotLotteryList,this.lotteryTypeCode,'=========================')
      this.lotteryCode = this.ltList(this.lotteryTypeCode)[0]['lotteryCode']
      this.lotteryTypeCode = this.$route.query.lotteryTypeCode || this.lotteryTypeCode;
      this.lotteryCode = this.$route.query.lotteryCode || this.lotteryCode;
      this.$store.commit("lottery/setlotteryTypeCode", this.lotteryTypeCode);
      this.$store.commit("lottery/setlotteryCode", this.lotteryCode);
      // this.$store.dispatch("lottery/queryHisPeriodsPage"); // 获取开奖历史
      // this.$store.dispatch("lottery/getLotteryLatelyLoop"); // 定时任务
      this.$store.dispatch("lottery/getLotterylist"); // 所有彩种
      this.$router.push({
        name: "lotteryrecord",
        query: {
          lotteryTypeCode: this.lotteryTypeCode,
          lotteryCode: this.lotteryCode,
        },
      });
    },
    setIshowIdx(idx) {
      this.isShow = idx;
    },
    ltList(type) {
      let arr = this.$store.state.lottery.LotteryLatelyLpVo.filter((item, i) => {
        return item.lotteryTypeCode == type
      })
      return arr
    }
  }
};
</script>
<style lang="less">
body {
  -webkit-overflow-scrolling: touch;
  background-color: #e5e5e5;
  background-image: url('../assets/dfbg.png');
  background-repeat: no-repeat;
  background-size: 134vw;
  background-position-x: center;
  background-attachment: fixed;
}

.record-menu-components-df {
  box-shadow: 0 2px 12px rgba(0, 0, 0, .08);
  width: 100%;
  background: #fff;
  height: 50px;

  .mian {
    box-sizing: inherit;
    font-size: 16px;
    height: 100%;

    .wrapRecord {
      padding: 30px 40px;
      box-shadow: 0 0 8px rgba(0, 0, 0, .08);
      border: 1px solid #d3d3d3;
      background: #fff;

      .grid_container {
        font-size: 14px;
        box-sizing: border-box;
      }

      .grid_header {
        border-bottom: 1px solid #d3d3d3;
        border-right: 1px solid #d3d3d3;
        display: grid;
        grid-template-columns: 180px 140px 2fr 219px;
        background: #f5f5f5;
      }

      .fiveColumn {
        grid-template-columns: 180px 140px 2fr 147px 133px
      }


      .grid_column {
        display: grid;
        place-content: center;
        border-top: 1px solid #d3d3d3;
        border-left: 1px solid #d3d3d3;
        grid-auto-flow: column;
        height: 50px;

        .innerTitle {
          border: 1px solid #d3d3d3;
          border-radius: 2px;
          padding: 5px 10px;
          background: #fff;
          cursor: pointer
        }

        .clicked {
          background: #19aecf;
          border: 1px solid #19aecf;
          color: #fff
        }
      }
    }

    .grid_header>.grid_column .innerTitle+.innerTitle {
      margin-left: 10px
    }

    .record-lottery-component {
      width: 1200px;
      margin: 20px auto;
    }

    .kaijiangjilubox {
      display: flex;
      justify-content: space-between;
      border-bottom: 1px solid #d3d3d3;
      padding: 0 40px;
      background: #f5f5f5;
      color: #333;
      font-size: 14px;
      height: 60px;
      box-sizing: border-box;

      .kaijiangjilu {
        font-size: 18px;
        font-weight: 500;
        color: #555;
        display: inline-block;
        line-height: 60px;
      }

    }

    .wrap {
      width: 1200px;
      margin: 0 auto;

      .menulist {
        display: flex;
        align-items: center;
        font-size: 16px;
        height: 50px;
        background: #fff;
      }

      .menu_item {
        width: 80px;
      }

      .menu_title {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 16px;
        color: #000
      }

      ul.inner_menu {
        transition: .5s;
        position: absolute;
        z-index: 10;
        background: #fff;
        box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
        height: auto;
        grid-template-columns: 1fr 1fr;
        width: -webkit-max-content;
        width: -moz-max-content;
        width: max-content;
        cursor: pointer;
        top: 50px;
        left: 0;
      }

      .menu_item {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 50px;
        color: #666;
        margin-right: 21px;
        cursor: pointer;
        position: relative;
        padding: 0 5px
      }

      .arrow {
        transition: .3s;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 6px 4px 0 4px;
        border-color: #999 transparent transparent transparent;
        transform: rotate(0deg);
        margin-left: 6px
      }
    }
  }
}


.wrap .menu_item:hover .arrow {
  border-color: #ec5141 transparent transparent transparent;
  transform: rotate(180deg)
}

.home-menu-component .wrap .menuItem {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  color: #666;
  margin-right: 21px;
  cursor: pointer;
  position: relative;
  padding: 0 5px;
}

.wrap .wrapper_menu+.wrapper_menu {
  margin-left: 43px
}

.wrap ul.inner_menu>li {
  padding: 5px;
  margin: 5px 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center
}

.wrap ul.inner_menu>li:hover {
  color: #fff;
  background: #ec5141
}

.wrap ul.wrapper_menu>li:hover:after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #ec5141
}

.wrap ul.column-one {
  grid-template-columns: 1fr !important
}

.wrap ul.column-two {
  grid-template-columns: 1fr 1fr !important
}

.wrap ul.column-three {
  grid-template-columns: 1fr 1fr 1fr !important
}

.wrap ul.column-four {
  grid-template-columns: repeat(4, 1fr)
}

.wrap ul.wrapper_menu>li {
  position: relative
}

.wrap ul.wrapper_menu>li:hover {
  color: #ec5141
}

.wrap ul.wrapper_menu>li:hover:after {
  content: "";
  display: inline-block;
  width: 100%;
  height: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #ec5141
}

.wrap ul.wrapper_menu:hover.inner_menu {
  display: grid
}

.wrap ul.inner_menu {
  transition: .5s;
  display: none;
  position: absolute;
  z-index: 10;
  background: #fff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, .24);
  height: auto;
  grid-template-columns: 1fr 1fr;
  width: -webkit-max-content;
  width: -moz-max-content;
  width: max-content;
  cursor: pointer
}
</style>